import React from 'react';
import AppListToolbarGlobal, { type CompanyOption } from '@/__core/components/AppLisstToolbarGlobal';
import { InsurancePeriodPicker } from '@/modules/organizations/utils/insurancePeriodUtils';

export interface FinancialReportToolbarGlobalProps {
  /** @deprecated Chỉ dùng khi test; mặc định lấy từ auth + resolveModuleAccessibleCompanies */
  companies?: CompanyOption[];
  fetchCompanies?: () => Promise<CompanyOption[]>;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  onSearchSubmit?: () => void;
  onToggleAdvancedSearch?: () => void;
  isAdvancedSearchOpen?: boolean;
  onFilterChange?: (field: string, value: string) => void;

  filters?: {
    company: string;
  };
  selectedPeriod?: Date | null;
  onPeriodChange?: (value: Date | null) => void;
}

export default function FinancialReportToolbarGlobal({
  companies,
  filters = { company: 'all' },
  onFilterChange,
  selectedPeriod = new Date(),
  onPeriodChange,
}: FinancialReportToolbarGlobalProps) {
  const periodPicker = React.useMemo(
    () => <InsurancePeriodPicker selectedPeriod={selectedPeriod} onPeriodChange={onPeriodChange} />,
    [onPeriodChange, selectedPeriod]
  );

  return (
    <AppListToolbarGlobal
      scopeModule='financial-report'
      companies={companies}
      showSearch={false}
      leftSection={periodPicker}
      searchPlaceholder=''
      searchQuery=''
      isAdvancedSearchOpen={false}
      selectedCompany={filters.company}
      onCompanyChange={(id) => onFilterChange?.('company', id)}
      advancedFilterFields={[]}
    />
  );
}
